import React from 'react';
import {ErrorSnackbar} from '.';
import {useChatErrorSnackbarStore} from './store/useChatErrorSnackbarStore';

export function GlobalChatErrorSnackbar() {
    const open = useChatErrorSnackbarStore(state => state.open);
    const setOpen = useChatErrorSnackbarStore(state => state.setOpen);
    return <ErrorSnackbar open={open} onClose={() => setOpen(false)} />;
}
